import React, { useRef } from 'react'
import { BarChart, CartesianGrid, ResponsiveContainer } from 'recharts'

import { ChartTooltip, XAxis, YAxis, Bar } from '../../../Visualisation/components'
import { useBarChartHoverIndex } from '../../../Visualisation/hooks'
import { formatGraphData, getAxisDomain, getMonthlyInterval } from '../../../Visualisation/helpers'
import { GraphPayload } from '../../../Visualisation/types'

type Props = {
  data?: GraphPayload
  graphHeight?: number
}

const CPVChart: React.FC<Props> = ({ data, graphHeight }) => {
  const chartRef = useRef<any>(null)
  const [hoveredIndex, handleBarMouseMove, handleBarMouseLeave] = useBarChartHoverIndex()

  const formattedData = formatGraphData('cpv', undefined, data, value => Number(value))

  const domain = getAxisDomain(formattedData, 'cpv')

  const monthlyInterval = getMonthlyInterval(13, data)

  return (
    <ResponsiveContainer width={'99%'} height={graphHeight}>
      <BarChart
        ref={chartRef}
        data={formattedData}
        barCategoryGap={3}
        maxBarSize={50}
        margin={{ top: 0, left: -15, right: 0, bottom: 0 }}
        onMouseMove={handleBarMouseMove}
        onMouseLeave={handleBarMouseLeave}
      >
        <defs>
          <linearGradient id="color-red" x1="0" y1="0" x2="0" y2="1">
            <stop stopColor="#FDC3C8" />
            <stop offset="1" stopColor="#FECDD1" />
          </linearGradient>
          <linearGradient id="color-red-hovered" x1="0" y1="0" x2="0" y2="1">
            <stop stopColor="#FB606D" />
            <stop offset="1" stopColor="#FC7E88" />
          </linearGradient>
        </defs>
        {XAxis({ monthFormat: 'three', chartType: 'bar', barSize: 50, monthlyInterval })}
        {YAxis({ dataKey: 'cpv', unit: '₽', domain })}
        <CartesianGrid stroke="#CED8FD" vertical={false} strokeDasharray="5 5" />
        {ChartTooltip({ cursor: false })}
        {Bar({
          dataKey: 'cpv',
          stroke: '#FB606D',
          unit: '₽',
          hoveredIndex,
          borderRadius: 15,
          graphData: formattedData,
          color: 'url(#color-red)',
          colorHovered: 'url(#color-red-hovered'
        })}
      </BarChart>
    </ResponsiveContainer>
  )
}

export default CPVChart
